module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/flowing-text.b5739ba1.png";